<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSfP4bFX6GrwSSujMwXJUvoC289YEKGHKTpS74QBME5GB8GBdw/viewform?embedded=true"
        width="540"
        height="560"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >Loading…</iframe>
      <p>
        <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "Feedback",
  components: {
    DashHeader
  }
};
</script>
<style scoped >
.signature {
  text-align: right;
}
</style>